module.exports = __webpack_public_path__ + "c21ba5ba3d01b2b37c2224fc31864af8.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/stones-throw-hat.png
 ** module id = 479
 ** module chunks = 0
 **/